import { ValueType } from "./types";

// Colors
export const NEUTRAL_LIGHTER_COLOR = "#E5E9ED";
export const NEUTRAL_LIGHT_COLOR = "#C8CDD3";
export const NEUTRAL_MID_COLOR = "#919599";
export const NEUTRAL_BLACK_COLOR = "#000000";
export const NEUTRAL_DARK_COLOR = "#49494D";
export const GL_BRIGHT_COLOR = "#006DD9";
export const ERROR_COLOR = "#EE3E54";
export const BASE_DARK_COLOR = "#1C1B1F";

export const BORDER_RADIUS = "5px";

export const VALUE_TYPE_TO_TYPE_ATTR: Record<ValueType, string> = {
  text: "text",
  numeric: "text",
  password: "password",
  email: "email",
};

export const VALUE_TYPE_TO_INPUT_MODE: Record<
  ValueType,
  React.HTMLAttributes<HTMLInputElement>["inputMode"] | undefined
> = {
  text: undefined,
  numeric: "numeric",
  password: undefined,
  email: "email",
};
